import apiClient from "./client";

export const getAdminSolutions = async () => {
  const response = await apiClient.get("/solutions/admin");
  return response.data;
};

/** Full solution admin row (`pdfDocuments`, `pdfs`, etc.). List endpoint may omit PDF fields. */
export const getAdminSolutionById = async (id) => {
  const response = await apiClient.get(`/solutions/admin/${id}`);
  return response.data;
};

export const createAdminSolution = async (payload) => {
  const response = await apiClient.post("/solutions/admin", payload);
  return response.data;
};

export const updateAdminSolution = async ({ id, payload }) => {
  const response = await apiClient.put(`/solutions/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminSolution = async ({ id }) => {
  await apiClient.delete(`/solutions/admin/${id}`);
};

const assertPdfFile = (file) => {
  if (!file) {
    throw new Error("Please select a PDF file.");
  }
  const byMime = String(file.type || "").toLowerCase() === "application/pdf";
  const byName = /\.pdf$/i.test(String(file.name || ""));
  if (!byMime && !byName) {
    throw new Error("Only PDF files are allowed.");
  }
};

export const createAdminSolutionPdf = async ({ id, title }) => {
  const body = { title: String(title || "").trim() };
  const response = await apiClient.post(`/solutions/admin/${id}/pdfs`, body);
  return response.data;
};

export const updateAdminSolutionPdf = async ({ id, pdfId, payload }) => {
  const response = await apiClient.put(`/solutions/admin/${id}/pdfs/${pdfId}`, payload);
  return response.data;
};

export const uploadAdminSolutionPdfFile = async ({ id, pdfId, file }) => {
  assertPdfFile(file);
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/solutions/admin/${id}/pdfs/${pdfId}/file`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminSolutionPdf = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/solutions/admin/${id}/pdfs/${pdfId}`);
  return response.data;
};

export const clearAdminSolutionPdfFile = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/solutions/admin/${id}/pdfs/${pdfId}/file`);
  return response.data;
};
